import { render, staticRenderFns } from "./add-partner.vue?vue&type=template&id=484dbef6&scoped=true&"
import script from "./add-partner.vue?vue&type=script&lang=js&"
export * from "./add-partner.vue?vue&type=script&lang=js&"
import style0 from "./add-partner.vue?vue&type=style&index=0&id=484dbef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484dbef6",
  null
  
)

export default component.exports